import React from "react";
import styles from "../../assets/styles/Broadcast/Broadcast.module.scss";
import {
  AppPage,
  MimaButton,
  MimaDateInput,
  MimaDropdown,
  MimaDropZone,
  MimaInput,
  MimaMultiDropdown,
  MimaMultiPaginatedDropdown,
  MimaText,
  MimaTextArea,
  ReceiptCheckBox as RCB,
  ReactQuillInput,
} from "../../components";
import { Formik } from "formik";
import { values } from "mobx";
import { adminStore } from "../../stores";

const CloneBroadcast = ({
  onSubmit,
  validationSchema,
  loading,
  fashPlans,
  mimaPlans,
  broadcast,
  tags,
  setCompetition,
  setStage,
}) => {
  const isCopied = Object.keys(broadcast).length > 0;

  const participantsArray = adminStore.participants;

  const subPlans = [
    {
      value: "All",
      key: "",
    },
  ];
  const fashPlanList = [...subPlans, ...fashPlans];
  const mimaPlanList = [...subPlans, ...mimaPlans];

  const tagList = tags.map((x) => ({
    value: x,
    key: x,
  }));

  return (
    <AppPage pageTitle="Broadcast">
      <MimaText variant="subtitleBold" mb={4} align="center">
        Clone Broadcast
      </MimaText>
      <div className={styles.formContainer}>
        <Formik
          initialValues={{
            title: isCopied ? broadcast?.title : "",
            content: isCopied ? broadcast?.content : "",
            summary: isCopied ? broadcast?.summary : "",
            startDate: isCopied ? broadcast?.startDate : "",
            endDate: isCopied ? broadcast?.endDate : "",
            dateType: "",
            filterType: "",
            plan: "",
            planName: "",
            prospectTag: "",
            prospectTagName: "",
            broadCastFor: "",
            buttonTitle: isCopied
              ? broadcast?.actionButton?.title
              : values?.buttonTitle,
            buttonTitle2: isCopied
              ? broadcast?.actionButton2?.title2
              : values?.buttonTitle2,
            buttonUrl: isCopied
              ? broadcast?.actionButton?.url
              : values?.buttonUrl,
            buttonUrl2: isCopied
              ? broadcast?.actionButton2?.url2
              : values?.buttonUrl2,
            expectedDeliveryDateTime: isCopied
              ? new Date(broadcast?.expectedDeliveryDateTime)
              : "",
            isProspects: false,
            businesses: [],
            prospects: [],
            channels: isCopied ? broadcast.channels.map((x) => x) : [],
            hasBanner: isCopied && broadcast.bannerUrl ? true : false,
            files: broadcast.bannerUrl
              ? [
                  {
                    name: broadcast.bannerUrl,
                    preview: broadcast.bannerUrl,
                  },
                ]
              : [],
            app: "",
            subType: "",
            stage: "",
            competition: "",
            participants: [],
            competitions: [],
          }}
          onSubmit={onSubmit}
          validationSchema={validationSchema}
        >
          {({
            handleBlur,
            handleChange,
            handleSubmit,
            setFieldValue,
            values,
            errors,
            touched,
          }) => (
            <div className={styles.formContainer_form}>
              <MimaDropdown
                labelTitle="Select App"
                name="app "
                value={values.app}
                placeholder="--Select--"
                id="app "
                currentValue={values.app}
                width={50}
                onChange={(data) => {
                  setFieldValue("app", data.key);
                }}
                data={[
                  {
                    value: "FASH",
                    key: "FASH",
                  },
                  {
                    value: "MIMA",
                    key: "MIMA",
                  },
                  {
                    value: "MONEYEX",
                    key: "MONEYEX",
                  },
                ]}
                touched={touched.app}
                error={errors.app}
              />
              <MimaText variant="small" mb={1}>
                Broadcast For?
              </MimaText>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "2rem",
                  marginBottom: "4rem",
                }}
              >
                <RCB
                  title="Competition"
                  onChange={() => {
                    setFieldValue("broadCastFor", "COMPETITION");
                  }}
                  checked={values.broadCastFor === "COMPETITION"}
                  value="COMPETITION"
                  name="COMPETITION"
                />
                <RCB
                  title="Prospects"
                  onChange={() => {
                    setFieldValue("broadCastFor", "PROSPECTS");
                  }}
                  checked={values.broadCastFor === "PROSPECTS"}
                  value="PROSPECTS"
                  name="PROSPECTS"
                />
                <RCB
                  title="Customers"
                  onChange={() => {
                    setFieldValue("broadCastFor", "CUSTOMERS");
                  }}
                  checked={values.broadCastFor === "CUSTOMERS"}
                  value="CUSTOMERS"
                  name="CUSTOMERS"
                />
              </div>

              {/* <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "2rem",
                  marginBottom: "4rem",
                }}
              >
                <RCB
                  title="Prospects"
                  onChange={() => {
                    setFieldValue("isProspects", true);
                  }}
                  checked={values.isProspects}
                  value={values.isProspects}
                  name="isProspects"
                />
                <RCB
                  title="Customers"
                  onChange={() => {
                    setFieldValue("isProspects", false);
                  }}
                  checked={!values.isProspects}
                  value={!values.isProspects}
                  name="isProspects"
                />
              </div> */}

              <MimaMultiDropdown
                labelTitle="Broadcast Channel"
                name="channels"
                id="channels"
                value={values.channels}
                placeholder="Select Broadcast Channel"
                currentValue={values.channels}
                onChange={(data) => {
                  setFieldValue("channels", data);
                }}
                data={
                  values.broadCastFor === "PROSPECTS" ||
                  values.broadCastFor === "COMPETITION"
                    ? [
                        { key: "EMAIL", value: "EMAIL" },
                        { key: "SMS", value: "SMS" },
                      ]
                    : [
                        { key: "EMAIL", value: "EMAIL" },
                        { key: "SMS", value: "SMS" },
                        { key: "PUSH", value: "PUSH" },
                      ]
                }
                touched={touched.channels}
                error={errors.channels}
                width={50}
              />
              <MimaDropdown
                labelTitle="Filter Type"
                name="filterType"
                value={values.filterType}
                placeholder="Select Filter Type"
                id="filterType"
                currentValue={values.filterType}
                width={50}
                onChange={(data) => {
                  setFieldValue("filterType", data.key);
                }}
                data={[
                  { value: "DATE", key: "DATE" },
                  ...(values.broadCastFor === "PROSPECTS"
                    ? [{ value: "TAG", key: "TAG" }]
                    : []),
                  ...(values.broadCastFor === "COMPETITION"
                    ? [{ value: "COMPETITION", key: "COMPETITION" }]
                    : []),
                  ...(values.app !== "MONEYEX" &&
                  values.broadCastFor === "CUSTOMERS"
                    ? [{ value: "PLAN", key: "PLAN" }]
                    : []),
                  { value: "DIRECT", key: "DIRECT" },
                ]}
                touched={touched.filterType}
                error={errors.filterType}
              />

              {values.broadCastFor === "PROSPECTS" &&
                values.filterType === "DIRECT" && (
                  <MimaMultiPaginatedDropdown
                    labelTitle="Prospects"
                    name="prospects"
                    id="prospects"
                    value={values.prospects}
                    placeholder="Select prospects"
                    currentValue={values.prospects}
                    onChange={(data) => {
                      setFieldValue("prospects", data);
                    }}
                    touched={touched.prospects}
                    error={errors.prospects}
                    queryKey={["getProspects"]}
                    optionLabel="fullname"
                    url="/customers/admin/prospects"
                    getPageValue={(page) => page?.data?.prospects || []}
                    getPageTotalCount={(lastPage) => lastPage?.data?.count || 0}
                    width={50}
                  />
                )}

              {values.broadCastFor === "COMPETITION" &&
                values.filterType === "DIRECT" && (
                  <div>
                    <MimaMultiPaginatedDropdown
                      labelTitle="Competitions"
                      name="competition"
                      id="competition"
                      value={values.competition}
                      placeholder="Select Competition"
                      currentValue={values.competition}
                      onChange={(data) => {
                        setFieldValue("competition", data);
                        setCompetition(data);
                      }}
                      touched={touched.competition}
                      error={errors.competition}
                      queryKey={["getAllCompetitions"]}
                      optionLabel="name"
                      url="/competition/competitions"
                      getPageValue={(page) => page?.data?.competitions || []}
                      getPageTotalCount={(lastPage) =>
                        lastPage?.data?.count || 0
                      }
                      width={50}
                    />
                    <MimaDropdown
                      labelTitle="Competition stage"
                      name="stage"
                      value={values.stage}
                      placeholder="--Select--"
                      id="stage"
                      currentValue={values.stage}
                      onChange={(data) => {
                        setFieldValue("stage", data.key);
                        setStage(data.key);
                      }}
                      data={[
                        { value: "REG", key: "REG" },
                        { value: "ONE", key: "ONE" },
                        { value: "TWO", key: "TWO" },
                        { value: "END", key: "END" },
                      ]}
                      width={50}
                      touched={touched.stage}
                      error={errors.stage}
                    />

                    {values.competitions && values.stage && (
                      <MimaMultiDropdown
                        labelTitle="Participants"
                        name="participants"
                        id="participants"
                        value={values.participants}
                        placeholder="Select Participants"
                        currentValue={values.participants}
                        onChange={(data) => {
                          setFieldValue("participants", data);
                        }}
                        data={participantsArray}
                        touched={touched.participants}
                        error={errors.participants}
                        mt={2}
                        mb={2}
                        width={50}
                      />
                    )}
                  </div>
                )}
              {values.broadCastFor === "CUSTOMERS" &&
                values.filterType === "DIRECT" && (
                  <MimaMultiPaginatedDropdown
                    labelTitle="Businesses"
                    name="businesses"
                    id="businesses"
                    value={values.businesses}
                    placeholder="Select Businesses"
                    currentValue={values.businesses}
                    onChange={(data) => {
                      setFieldValue("businesses", data);
                    }}
                    touched={touched.businesses}
                    error={errors.businesses}
                    queryKey={["getAllSignedBusinesses"]}
                    optionLabel="tradingName"
                    url="/businesses"
                    getPageValue={(page) => page?.data?.businesses || []}
                    getPageTotalCount={(lastPage) => lastPage?.data?.count || 0}
                    width={50}
                  />
                )}

              {values.filterType === "COMPETITION" && (
                <MimaMultiPaginatedDropdown
                  labelTitle="Competitions"
                  name="competitions"
                  id="competitions"
                  value={values.competitions}
                  placeholder="Select Competition"
                  currentValue={values.competitions}
                  onChange={(data) => {
                    setFieldValue("competitions", data);
                  }}
                  touched={touched.competitions}
                  error={errors.competitions}
                  queryKey={["getAllCompetitions"]}
                  optionLabel="name"
                  url="/competition/competitions"
                  getPageValue={(page) => page?.data?.competitions || []}
                  getPageTotalCount={(lastPage) => lastPage?.data?.count || 0}
                  width={50}
                />
              )}

              {/* <MimaMultiDropdown
                labelTitle="Broadcast Channel"
                name="channels"
                id="channels"
                value={values.channels}
                placeholder="Select Broadcast Channel"
                currentValue={values.channels}
                onChange={(data) => {
                  setFieldValue("channels", data);
                }}
                data={
                  values.isProspects
                    ? [
                        { key: "EMAIL", value: "EMAIL" },
                        { key: "SMS", value: "SMS" },
                      ]
                    : [
                        { key: "EMAIL", value: "EMAIL" },
                        { key: "SMS", value: "SMS" },
                        { key: "PUSH", value: "PUSH" },
                      ]
                }
                touched={touched.channels}
                error={errors.channels}
                width={50}
              />

              <MimaDropdown
                labelTitle="Filter Type"
                name="filterType"
                value={values.filterType}
                placeholder="Select Filter Type"
                id="filterType"
                currentValue={values.filterType}
                width={50}
                onChange={(data) => {
                  setFieldValue("filterType", data.key);
                }}
                data={[
                  { value: "DATE", key: "DATE" },
                  ...(values.isProspects ? [{ value: "TAG", key: "TAG" }] : []),
                  ...(values.app !== "MONEYEX" && !values.isProspects
                    ? [{ value: "PLAN", key: "PLAN" }]
                    : []),
                  { value: "DIRECT", key: "DIRECT" },
                ]}
                touched={touched.filterType}
                error={errors.filterType}
              />

              {values.isProspects && values.filterType === "DIRECT" && (
                <MimaMultiPaginatedDropdown
                  labelTitle="Prospects"
                  name="prospects"
                  id="prospects"
                  value={values.prospects}
                  placeholder="Select prospects"
                  currentValue={values.prospects}
                  onChange={(data) => {
                    setFieldValue("prospects", data);
                  }}
                  touched={touched.prospects}
                  error={errors.prospects}
                  queryKey={["getProspects"]}
                  optionLabel="fullname"
                  url="/customers/admin/prospects"
                  getPageValue={(page) => page?.data?.prospects || []}
                  getPageTotalCount={(lastPage) => lastPage?.data?.count || 0}
                  width={50}
                />
              )}

              {!values.isProspects && values.filterType === "DIRECT" && (
                <MimaMultiPaginatedDropdown
                  labelTitle="Businesses"
                  name="businesses"
                  id="businesses"
                  value={values.businesses}
                  placeholder="Select Businesses"
                  currentValue={values.businesses}
                  onChange={(data) => {
                    setFieldValue("businesses", data);
                  }}
                  touched={touched.businesses}
                  error={errors.businesses}
                  queryKey={["getAllSignedBusinesses"]}
                  optionLabel="tradingName"
                  url="/businesses"
                  getPageValue={(page) => page?.data?.businesses || []}
                  getPageTotalCount={(lastPage) => lastPage?.data?.count || 0}
                  width={50}
                />
              )} */}

              {values.filterType === "TAG" && (
                <MimaDropdown
                  labelTitle="Tag"
                  name="prospectTag"
                  value={values.prospectTag}
                  placeholder="Select Tag"
                  id="prospectTag"
                  currentValue={values.prospectTag}
                  onChange={(data) => {
                    setFieldValue("prospectTag", data.key);
                    setFieldValue("prospectTagName", data.value);
                  }}
                  data={tagList}
                  width={50}
                  touched={touched.prospectTagName}
                  error={errors.prospectTagName}
                />
              )}

              {values.filterType === "PLAN" && (
                <>
                  <MimaDropdown
                    labelTitle="Subscription state"
                    name="subType"
                    value={values.subType}
                    placeholder="--Select--"
                    id="subType"
                    currentValue={values.subType}
                    onChange={(data) => {
                      setFieldValue("subType", data.key);
                    }}
                    data={[
                      { value: "TRIAL", key: "TRIAL" },
                      { value: "FREE-PLAN", key: "FREE-PLAN" },
                      {
                        value: "ALL-ACTIVE-SUBSCRIBED-USERS",
                        key: "ALL-ACTIVE-SUBSCRIBED-USERS",
                      },
                      {
                        value: "ACTIVE-PAYING-SUBSCRIBED-USERS",
                        key: "ACTIVE-PAYING-SUBSCRIBED-USERS",
                      },
                      {
                        value: "EXPIRED-PAYING-SUBSCRIBED-USERS",
                        key: "EXPIRED-PAYING-SUBSCRIBED-USERS",
                      },
                    ]}
                    width={50}
                    touched={touched.planName}
                    error={errors.planName}
                  />
                </>
              )}

              {values.filterType === "PLAN" &&
                values.subType !== "TRIAL" &&
                values.subType !== "FREE-PLAN" && (
                  <>
                    <MimaDropdown
                      labelTitle="Plan"
                      name="plan"
                      value={values.plan}
                      placeholder="Select Plan"
                      id="plan"
                      currentValue={values.plan}
                      onChange={(data) => {
                        setFieldValue("plan", data.key);
                        setFieldValue("planName", data.value);
                      }}
                      data={
                        values.app === "MIMA"
                          ? mimaPlanList
                          : values.app === "FASH"
                            ? fashPlanList
                            : ""
                      }
                      width={50}
                      touched={touched.planName}
                      error={errors.planName}
                    />
                  </>
                )}

              {values.filterType === "DATE" && (
                <>
                  <MimaDropdown
                    labelTitle="Date Type"
                    name="dateType"
                    value={values.dateType}
                    placeholder="Select Date Type"
                    id="dateType"
                    currentValue={values.dateType}
                    onChange={(data) => {
                      setFieldValue("dateType", data.key);
                    }}
                    data={
                      values.isProspects
                        ? [
                            {
                              value: "CREATED AT",
                              key: "CREATED-AT",
                            },
                          ]
                        : [
                            {
                              value: "LAST LOGIN",
                              key: "LAST-LOGIN",
                            },
                            {
                              value: "CREATED AT",
                              key: "CREATED-AT",
                            },
                            {
                              value: "EXPIRED AT",
                              key: "EXPIRED-AT",
                            },
                            {
                              value: "TRIAL EXPIRED AT",
                              key: "TRAIL-EXPIRED-AT",
                            },
                            {
                              value: "SUBSCRIBED AT",
                              key: "SUBSCRIBED-AT",
                            },
                          ]
                    }
                    width={50}
                    touched={touched.dateType}
                    error={errors.dateType}
                  />

                  <div className={styles.beside}>
                    <MimaDateInput
                      labelTitle="Start date"
                      name="startDate"
                      value={values.startDate}
                      onChange={(text) => {
                        setFieldValue("startDate", text);
                      }}
                      onBlur={handleBlur}
                      width={24}
                      touched={touched.startDate}
                      error={errors.startDate}
                    />

                    <MimaDateInput
                      labelTitle="End date"
                      name="endDate"
                      value={values.endDate}
                      onChange={(text) => {
                        setFieldValue("endDate", text);
                      }}
                      onBlur={handleBlur}
                      width={24}
                      touched={touched.endDate}
                      error={errors.endDate}
                    />
                  </div>
                </>
              )}

              {(values.channels.includes("EMAIL") ||
                values.channels.includes("PUSH")) && (
                <MimaInput
                  labelTitle="Broadcast Title"
                  name="title"
                  placeholder="Title"
                  value={values.title}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.title}
                  touched={touched.title}
                  width={50}
                />
              )}
              {(values.channels.includes("SMS") ||
                values.channels.includes("PUSH")) && (
                <MimaTextArea
                  labelTitle="Broadcast Summary"
                  name="summary"
                  placeholder="Enter Summary"
                  value={values.summary}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.summary}
                  touched={touched.summary}
                  width={50}
                />
              )}
              {values.channels.includes("EMAIL") && (
                <>
                  <ReactQuillInput
                    name="content"
                    labelTitle="Content"
                    error={errors.content}
                    touched={touched.content}
                    placeholder="Enter content"
                    width={50}
                    mt={2}
                    mb={5}
                  />

                  <MimaText variant="small" mb={1}>
                    Does this Broadcast have a banner?
                  </MimaText>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      gap: "2rem",
                      marginBottom: "4rem",
                    }}
                  >
                    <RCB
                      title="Yes"
                      onChange={() => {
                        setFieldValue("hasBanner", true);
                      }}
                      checked={values.hasBanner}
                      value={values.hasBanner}
                      name="hasBanner"
                    />
                    <RCB
                      title="No"
                      onChange={() => {
                        setFieldValue("hasBanner", false);
                      }}
                      checked={!values.hasBanner}
                      value={!values.hasBanner}
                      name="hasBanner"
                    />
                  </div>
                  {values.hasBanner === true && (
                    <div style={{ width: "50rem" }}>
                      <MimaDropZone
                        title="Upload Banner Image"
                        info="maximum image Size 1MB"
                        maxNumOfImages={1}
                        files={values.files}
                        setFiles={(newFiles) => {
                          setFieldValue("files", newFiles);
                        }}
                        labelTitle="Upload Image"
                        name="bannerUrl"
                      />
                    </div>
                  )}
                </>
              )}

              {values.channels.includes("EMAIL") && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "2rem",
                  }}
                >
                  <MimaInput
                    labelTitle="Action Button Title"
                    name="buttonTitle"
                    placeholder="Enter Title"
                    value={values.buttonTitle}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors?.buttonTitle}
                    touched={touched?.buttonTitle}
                    variant="form"
                  />
                  <MimaInput
                    labelTitle="Action Button Url"
                    name="buttonUrl"
                    placeholder="Enter URL"
                    value={values.buttonUrl}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors?.buttonUrl}
                    touched={touched?.buttonUrl}
                    variant="form"
                  />
                </div>
              )}

              {values.channels.includes("EMAIL") && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "2rem",
                  }}
                >
                  <MimaInput
                    labelTitle="Action Button Title 2 (Optional)"
                    name="buttonTitle2"
                    placeholder="Enter Title"
                    value={values.buttonTitle2}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    variant="form"
                  />
                  <MimaInput
                    labelTitle="Action Button Url 2 (Optional)"
                    name="buttonUrl2"
                    placeholder="Enter URL"
                    value={values.buttonUrl2}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    variant="form"
                  />
                </div>
              )}

              <MimaDateInput
                labelTitle="Expected Delivery Date"
                name="expectedDeliveryDateTime"
                value={values.expectedDeliveryDateTime}
                onChange={(text) => {
                  setFieldValue("expectedDeliveryDateTime", text);
                }}
                onBlur={handleBlur}
                showTimeSelect
                touched={touched.expectedDeliveryDateTime}
                error={errors.expectedDeliveryDateTime}
                width={50}
                mt={2}
              />

              <MimaButton
                title="Continue"
                width={50}
                buttonColor="var(--color-dark-4)"
                onClick={handleSubmit}
                loading={loading}
              />
            </div>
          )}
        </Formik>
      </div>
    </AppPage>
  );
};
export default CloneBroadcast;
